/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M2 21L8.99999 14L11 12M16 13L20.7373 8.26274C21.5293 7.47071 21.9253 7.07469 22.0737 6.61803C22.2042 6.21635 22.2042 5.78365 22.0737 5.38197C21.9253 4.92531 21.5293 4.52929 20.7373 3.73726L20 3L13 10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M20 21L9.00003 10M8.52557 4.47445C10.1657 6.11457 10.6099 8.32958 8.96973 9.96971C7.32961 11.6098 5.11453 11.1657 3.47441 9.52554C1.83429 7.88542 1.3902 5.67042 3.03032 4.0303C4.67045 2.39018 6.88545 2.83433 8.52557 4.47445Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M8.52557 4.47445C10.1657 6.11457 10.6099 8.32958 8.96973 9.96971C7.32961 11.6098 5.11453 11.1657 3.47441 9.52554C1.83429 7.88542 1.3902 5.67042 3.03032 4.0303C4.67045 2.39018 6.88545 2.83433 8.52557 4.47445Z"
				fill="currentColor"
			/>
			<path
				d="M2 21L8.99999 14L11 12M16 13L20.7373 8.26274C21.5293 7.47071 21.9253 7.07469 22.0737 6.61803C22.2042 6.21635 22.2042 5.78365 22.0737 5.38197C21.9253 4.92531 21.5293 4.52929 20.7373 3.73726L20 3L13 10M20 21L16.7 17.7L11.2 12.2L9 10M8.52554 4.47445C10.1657 6.11457 10.6098 8.32958 8.9697 9.96971C7.32958 11.6098 5.11451 11.1657 3.47439 9.52554C1.83426 7.88542 1.39018 5.67042 3.0303 4.0303C4.67042 2.39018 6.88542 2.83433 8.52554 4.47445Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.0559 3.94412C8.14666 3.03488 7.03408 2.41204 5.86379 2.27721C4.66903 2.13957 3.47935 2.52061 2.5 3.49997C1.52064 4.47932 1.13958 5.669 1.27721 6.86375C1.41202 8.03404 2.03484 9.14662 2.94408 10.0559C3.85333 10.9651 4.96593 11.588 6.13623 11.7228C7.10684 11.8346 8.07411 11.6041 8.92798 10.9886L9.93937 12L8.46969 13.4697L1.4697 20.4697C1.1768 20.7626 1.1768 21.2374 1.4697 21.5303C1.76259 21.8232 2.23746 21.8232 2.53036 21.5303L9.53035 14.5303L11 13.0607L16.1697 18.2303L19.4697 21.5303C19.7626 21.8232 20.2375 21.8232 20.5304 21.5303C20.8232 21.2374 20.8232 20.7626 20.5304 20.4697L17.2304 17.1697L11.7304 11.6697L11.5304 11.4697L9.98864 9.92795C10.6041 9.07409 10.8346 8.10684 10.7228 7.13624C10.588 5.96595 9.96514 4.85336 9.0559 3.94412ZM20.5304 2.46967C20.2375 2.17678 19.7626 2.17678 19.4697 2.46967L12.4697 9.46967C12.1768 9.76256 12.1768 10.2374 12.4697 10.5303L15.4697 13.5303C15.7626 13.8232 16.2375 13.8232 16.5304 13.5303L21.2676 8.79307L21.2892 8.77153C21.6669 8.39384 21.9821 8.07859 22.2186 7.80001C22.4653 7.50944 22.67 7.20979 22.787 6.8498C22.9665 6.29748 22.9665 5.70252 22.787 5.1502C22.67 4.79021 22.4653 4.49056 22.2186 4.2C21.9821 3.92143 21.6669 3.6062 21.2892 3.22855L21.2892 3.22847L21.2676 3.20693L20.5304 2.46967Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2 21L8.99999 14M16 13L20.7373 8.26274C21.5293 7.47071 21.9253 7.07469 22.0737 6.61803C22.2042 6.21635 22.2042 5.78365 22.0737 5.38197C21.9253 4.92531 21.5293 4.52929 20.7373 3.73726L20 3L13 10M20 21L16.7 17.7L11.2 12.2L9 10M4.00003 3.32471C3.66178 3.49135 3.33607 3.72466 3.03032 4.0304C1.3902 5.67052 1.83429 7.88552 3.47441 9.52564C5.11453 11.1658 7.32961 11.6099 8.96973 9.9698C10.6099 8.32968 10.1657 6.11467 8.52557 4.47455C8.36591 4.31489 8.20081 4.16657 8.03132 4.0304"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2 21L8.99999 14L11 12M16 13L20.7373 8.26274C21.5293 7.47071 21.9253 7.07469 22.0737 6.61803C22.2042 6.21635 22.2042 5.78365 22.0737 5.38197C21.9253 4.92531 21.5293 4.52929 20.7373 3.73726L20 3L13 10M20 21L16.7 17.7L11.2 12.2L9 10M8.52554 4.47445C10.1657 6.11457 10.6098 8.32958 8.9697 9.96971C7.32958 11.6098 5.11451 11.1657 3.47439 9.52554C1.83426 7.88542 1.39018 5.67042 3.0303 4.0303C4.67042 2.39018 6.88542 2.83433 8.52554 4.47445Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9.0559 3.94412C8.14666 3.03488 7.03408 2.41204 5.86379 2.27721C4.66903 2.13957 3.47935 2.52061 2.5 3.49997C1.52064 4.47932 1.13958 5.669 1.27721 6.86375C1.41202 8.03404 2.03484 9.14662 2.94408 10.0559C3.85333 10.9651 4.96593 11.588 6.13623 11.7228C7.10684 11.8346 8.07411 11.6041 8.92798 10.9886L10.6697 12.7303L16.1697 18.2303L19.4697 21.5303C19.7626 21.8232 20.2375 21.8232 20.5304 21.5303C20.8232 21.2374 20.8232 20.7626 20.5304 20.4697L17.2304 17.1697L11.7304 11.6697L9.98864 9.92795C10.6041 9.07409 10.8346 8.10684 10.7228 7.13624C10.588 5.96595 9.96514 4.85336 9.0559 3.94412Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20.5303 2.46967C20.2374 2.17678 19.7626 2.17678 19.4697 2.46967L12.4697 9.46967C12.1768 9.76256 12.1768 10.2374 12.4697 10.5303L15.4697 13.5303C15.7626 13.8232 16.2374 13.8232 16.5303 13.5303L21.2676 8.79307L21.2891 8.77153C21.6668 8.39384 21.9821 8.07859 22.2186 7.8C22.4653 7.50944 22.67 7.20979 22.787 6.8498C22.9664 6.29748 22.9664 5.70252 22.787 5.1502C22.67 4.79021 22.4653 4.49056 22.2186 4.2C21.9821 3.92142 21.6669 3.6062 21.2892 3.22855L21.2891 3.22847L21.2676 3.20693L20.5303 2.46967ZM11.5303 12.5303C11.8232 12.2374 11.8232 11.7626 11.5303 11.4697C11.2374 11.1768 10.7626 11.1768 10.4697 11.4697L8.46966 13.4697L1.46967 20.4697C1.17678 20.7626 1.17678 21.2374 1.46967 21.5303C1.76256 21.8232 2.23744 21.8232 2.53033 21.5303L9.53032 14.5303L11.5303 12.5303Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
